import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiFetch } from "@/services/api/common-api";
import { useWaveById } from "./useWaveById";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseIdentitiesSearchProps {
  readonly handle: string;
  readonly waveId: string | null;
}
export const IDENTITY_SEARCH_MIN_HANDLE_LENGTH = 3;
export function useIdentitiesSearch(t0) {
  const $ = _c(15);
  const {
    handle,
    waveId
  } = t0;
  const {
    wave
  } = useWaveById(waveId);
  let t1;
  if ($[0] !== handle || $[1] !== waveId) {
    t1 = [QueryKey.IDENTITY_SEARCH, {
      handle,
      waveId
    }];
    $[0] = handle;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handle || $[4] !== wave || $[5] !== waveId) {
    t2 = async () => {
      const params = {
        handle
      };
      if (waveId) {
        if (wave?.visibility.scope.group?.id) {
          params.group_id = wave.visibility.scope.group.id;
        } else {
          params.wave_id = waveId;
        }
        params.ignore_authenticated_user = "true";
      }
      return await commonApiFetch({
        endpoint: "identities",
        params
      });
    };
    $[3] = handle;
    $[4] = wave;
    $[5] = waveId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = handle.length >= IDENTITY_SEARCH_MIN_HANDLE_LENGTH;
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: identities
  } = useQuery(t4);
  let t5;
  if ($[11] !== identities) {
    t5 = identities ?? [];
    $[11] = identities;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = {
      identities: t5
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}